import React, { useEffect } from 'react';
import SwaggerUI, { SwaggerUIOptions } from 'swagger-ui';
import 'swagger-ui/dist/swagger-ui.css';
import useYamlParse from '../hooks/useYamlParse';
import { ConfigType } from '@/types/configType';
import filterSpec from '@/utils/filterSpec';
// @ts-ignore
import { SwaggerUIKongTheme } from 'swagger-ui-kong-theme';
import filterWorkspaceSpec from '@/utils/filterWorkspaceSpec';
import addSecurity from '@/utils/addSecurity';
import addSecurityDescription from '@/utils/addSecurityDescription';

interface Language {
  prismLanguage: string;
  target: string;
  client?: string;
}

interface SwaggerUIOptionsType extends SwaggerUIOptions {
  theme?: {
    swaggerAbsoluteTop?: string;
    hasSidebar?: boolean;
    languages?: Language[];
  };
}

const swaggerUIOptions: SwaggerUIOptionsType = {
  dom_id: '#ui-wrapper',
  docExpansion: 'list',
  deepLinking: true,
  defaultModelExpandDepth: 50,
  defaultModelRendering: 'model',
  filter: true,
  // @ts-ignore
  presets: [SwaggerUI.presets.apis, SwaggerUI.SwaggerUIStandalonePreset],
  // @ts-ignore
  plugins: [SwaggerUIKongTheme, SwaggerUI.plugins.DownloadUrl],
  layout: 'KongLayout',
  theme: {
    swaggerAbsoluteTop: '0px',
    hasSidebar: true,
    languages: [
      {
        prismLanguage: 'bash',
        target: 'shell',
        client: 'curl',
      },
      {
        prismLanguage: 'javascript',
        target: 'javascript',
      },
      {
        prismLanguage: 'python',
        target: 'python',
      },
      {
        prismLanguage: 'ruby',
        target: 'ruby',
      },
    ],
  },
};

function SwaggerLoader({ data }: { data: ConfigType }) {
  const getSpec = useYamlParse();

  const fetchSpec = async () => {
    let spec = await getSpec(data.url);

    if (data.group) {
      spec = filterSpec(spec, data.group);
    }
    const isWorkspaceSpec = data.url.includes('workspace');
    if (isWorkspaceSpec) {
      spec = filterWorkspaceSpec(spec);
    }

    spec = addSecurity(spec);
    spec = addSecurityDescription(spec, isWorkspaceSpec);

    SwaggerUI({
      ...swaggerUIOptions,
      spec,
      persistAuthorization: true,
    });
  };

  useEffect(() => {
    fetchSpec();
  }, [data.url, data.group]);

  return (
    <>
      <div id="ui-wrapper" />
    </>
  );
}

export default React.memo(SwaggerLoader);
